import React from 'react'
import './styles.scss'
import ProjectCard from './projects-card/project-card.component'
import IoTSmartDisImg from '../../assets/Iot-smart-display.jpg'
import IotHomeAutoImg from '../../assets/Iot-home-automation.jpg'
import SmartHelmetImg from '../../assets/smart-helmet.jpg'
import BikeBioImg from '../../assets/Bike-biometric.jpg'

function projects() {
    return (
        <div id="Our-Work" className="projects">
            <h1>Projects</h1>
            <div className="Cards">
                <ProjectCard Image={IoTSmartDisImg}
                    title="IoT Smart Display"
                    dscrip="This project aim is to build a display board which can be used by a common man himself.
            It reduced human time and effort. We have used latest technology to make the process simple and
            easy to manage. It's pretty much need your Voice and to give command via Google assitant.
            "
                    infoURL="https://www.instructables.com/Google-Assistant-Controlled-LED-Matrix-/"
                    completed="true"
                />
                <ProjectCard Image={IotHomeAutoImg}
                    title="IoT Home Automation"
                    dscrip="Controlling our devices with voice is special. so, we have used google assistant to take 
        voice commands. you can control your home appliances any where in the world via Internet.
         So, there is no misusing of technology. Home Smart Home.
        "
                    infoURL="https://easyelectronicsproject.com/esp32-projects/google-assistant-blynk-home-automation/"
                    completed="true"
                />
                <ProjectCard Image={SmartHelmetImg}
                    title="Smart Helmet - Demo"
                    dscrip="In our society 21% of accidents are happening due to Alchohol consumption. So, we decided to controll
        this situation with Smart Helmet. This smmart helmet transfers the alcoho percentage to the bike via wifi. If 
        the alcohol percent is high then the bike stops engine. 
        "
                    infoURL="https://drive.google.com/file/d/1E70NmG0HCshTJPJMigQL5z01FKsyQLAy/view?usp=sharing"
                    completed="true"
                />
                <ProjectCard Image={BikeBioImg}
                    title="Biometric Auth Bike"
                    dscrip="Even though your bike is locked there are so many cheat codes to unlock your motor bike.
        So, we came up with an Idea of Putting Biometric sensor to unlock your Bike. We are trying to make this
        affordable to each and every person. Our project can be embeded in old and new genertion bikes.
        "
                />
            </div>
        </div>
    )
}

export default projects
